import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiziHero from './components/ServiziHero';
import BrandCapitalSection from './components/BrandCapitalSection';
import StrutturaSection from './components/StrutturaSection';
import BCISection from './components/BCISection';
import PeriziaSection from './components/PeriziaSection';
import GovernanceSection from './components/GovernanceSection';
import PartnerSection from './components/PartnerSection';
import PreAnalisiSection from './components/PreAnalisiSection';
import { useSEO } from '../../utils/seo';

export function ServiziPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Servizi Valutazione Brand - Perizie Certificate e Consulenza Italia',
    description: 'Servizi completi di valutazione brand: perizie certificate, pre-analisi gratuite, governance del brand, consulenza per aziende e commercialisti. Metodologia scientifica riconosciuta in tutta Italia.',
    keywords: 'servizi valutazione brand, perizia certificata, consulenza brand, governance marchio, pre-analisi brand',
    canonical: `${siteUrl}/servizi`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Servizi di Valutazione Brand',
      description: 'Servizi completi di valutazione brand, perizie certificate e consulenza specializzata',
      provider: {
        '@type': 'ProfessionalService',
        name: 'Brand Capital',
        url: siteUrl
      },
      areaServed: 'IT',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servizi Brand Capital',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Pre-Analisi Gratuita',
              description: 'Analisi preliminare del valore del brand'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Perizia Certificata',
              description: 'Perizia completa e difendibile del valore del brand'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Governance del Brand',
              description: 'Consulenza strategica per la gestione del brand'
            }
          }
        ]
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServiziHero />
      <BrandCapitalSection />
      <StrutturaSection />
      <BCISection />
      <PeriziaSection />
      <GovernanceSection />
      <PartnerSection />
      <PreAnalisiSection />
      <Footer />
    </div>
  );
}

export default ServiziPage;
